//Layout
import Header from 'layout/header/Header';
import Capsule from 'layout/Capsule';

//Assets
import { IoCalendarOutline, IoCheckmarkOutline, IoChevronForwardOutline, IoHomeOutline } from 'react-icons/io5';

//Logic
import usePersonalBrand from './usePersonalBrand';
import OffcanvasServiceInfo from 'components/offcanvas/OffCanvasProductServiceInfo';
import cityImg from './img/city.png';
import { Button } from 'react-bootstrap';
import SkeletonDiv from 'components/loader/SkeletonDiv';
import AutocompleteAddress from 'components/autocomplete/AutocompleteAddress';
import SkeletonInput from 'components/loader/SkeletonInput';
import { useCallback, useState } from 'react';
import ReservationCalendar from 'pages/reservation/new/calendar/ReservationCalendar';
import { capitalizeFirstLetter, numb } from 'utils/helpers';
import { useAuthValue } from 'context/AuthContext';
import ReservationCheckout from 'pages/reservation/new/checkout/ReservationCheckout';
import ModalConfirm from 'pages/reservation/new/ModalConfirm';
import Checkout from 'components/Checkout';
import { BottomMenu } from 'pages/reservation/new/ReservationNew';

function PersonalBrand() {

    const {
        showOffCanvasServiceInfo, setShowOffCanvasServiceInfo,
        qty, handleChangeQty,
        productData,
        step, setStep,
        addressValue, setAddressValue,
        handleRetriveAddress, handleResetAddress,
        newAddress,
        selectedTimeSlot, setSelectedTimeSlot,
        cartItems,
        handleBack,
        buildingData,
        isInProgress,
        isCartInProgress,
        checkoutData, handleChangeCheckoutData,
        completeCheckout,
        couponData,
        applyCoupon,
        photographers,
        reservationConfirmData, handleCloseConfirm,
        user
    } = usePersonalBrand();

    const { subscription } = buildingData?.organization || {};


    return (
        <>
            <Header
                pageTitle={productData ? productData.description : <SkeletonDiv w={100} />}
                handleBack={handleBack}
            />

            <div className="extraHeader p-0 pb-1">
                <div className="form-wizard-section section-small">
                    <span className={`button-item ${step === 1 ? 'active' : ''}`}>
                        <strong>1</strong>
                        <p>Servizio</p>
                    </span>
                    <span className={`button-item ${step === 2 ? 'active' : ''}`}>
                        <strong>2</strong>
                        <p>Data</p>
                    </span>
                    <span className={`button-item ${step === 3 ? 'active' : ''}`}>
                        <strong>
                            <IoCheckmarkOutline />
                        </strong>
                        <p>Riepilogo</p>
                    </span>
                </div>
            </div>

            <Capsule className='extra-header-active pb-3'>

                {step === 1 && <>
                    <div style={{
                        overflow: 'hidden',
                        backgroundColor: '#f6f6f6',
                        backgroundImage: `url(${productData ? (productData.image_urls[1]?.url ?? productData.image_urls[0].url ?? cityImg) : cityImg})`,
                        backgroundSize: 'cover',
                        minHeight: '180px',
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                    }}>
                        <div
                        style={{
                            background: 'rgba(0, 0, 0, 0.71)',
                            WebkitBackdropFilter: 'blur(5px)',
                            width: '100%',
                            height: '100%',
                            minHeight: '180px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignContent: 'center',
                            textAlign: 'center',
                            alignItems: 'center',
                        }}
                        className='py-5'
                        >
                            <div className="header-large-title">
                                <h2 className="title lh-1 mt-0">{productData ? productData.service_title : <SkeletonDiv w={200} />}</h2>
                                <p className="text-14 mt-2 lh-base" style={{ maxWidth: '800px', margin: 'auto' }}>
                                    {productData ? productData.description_extend : <SkeletonDiv w={300} />}
                                </p>
                                <Button
                                    size="sm"
                                    className="btn-light mt-2"
                                    type="button"
                                    onClick={() => setShowOffCanvasServiceInfo(productData.id)}
                                >Visualizza esempi</Button>
                            </div>
                        </div>
                    </div>

                    <div className="section mt-3">
                        <div className="form-group boxed custom">
                            <div className="input-wrapper">
                                <div className="input-wrapper not-empty">
                                    {!productData ? <SkeletonInput /> : <>
                                        <AutocompleteAddress 
                                            value={addressValue}
                                            setValue={setAddressValue}
                                            handleRetrive={handleRetriveAddress}
                                            handleReset={handleResetAddress}
                                            defaultLockValue={productData?.service_address ? true : false}
                                            isEditable={!productData?.service_address}
                                            label={productData?.place_label}
                                            withGoogle
                                        />
                                    </>}
                                </div>
                            </div>
                        </div>

                        
                        {productData?.placeholder_note && (
                            <>
                                <h4 className="card-subtitle text-white text-12 mt-1">NOTE:</h4>
                                <div className="form-group boxed custom pt-0">
                                    <div className="input-wrapper">
                                        <textarea 
                                            rows="5" 
                                            className="form-control bg-amazon"
                                            placeholder={productData?.placeholder_note}
                                            value={checkoutData.note || ''}
                                            name="note"
                                            onChange={handleChangeCheckoutData}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    {productData && !!productData.moltiplier_active && (
                        <div className="section mt-1">
                            <ul className="listview no-after image-listview bg-transparent no-border p-0 mt-1 m-0">
                                <li>
                                    <div className="item p-0" style={{ minHeight: '33px' }}>
                                        <div className="in">
                                            <div className='fw-600'>{productData?.rate_label}</div>
                                            <div>
                                                <div className="stepper stepper-primary" style={{ height: '25px', width: '90px', minWidth: '90px', borderRadius: '6px', display: 'inline-flex', alignItems: 'flex-start', justifyContent: 'space-between', overflow: 'hidden' }}>
                                                    <a
                                                        className={`render-ambient stepper-button stepper-down ${qty <= 1 ? 'disabled' : ''}`}
                                                        onClick={() => handleChangeQty(qty - 1)}
                                                    >-</a>
                                                    <input 
                                                        value={qty}
                                                        type="text" 
                                                        readOnly
                                                        className="form-control text-white text-14" 
                                                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', padding: '0 3px', width: '33px', height: '25px' }}
                                                    />
                                                    <a 
                                                        className="render-ambient stepper-button stepper-up" 
                                                        onClick={() => handleChangeQty(qty + 1)}
                                                    >+</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    )}

                    <div className="section mt-2 mb-3">
                        <div className="section-title">
                            <h4 className="card-subtitle text-white text-12 mb-0">Riepilogo</h4>
                        </div>
                        <div className="card">
                            <ul className="listview simple-listview text-14 rounded">
                                <li className="bg-gray-dark fw-600">
                                    Subtotale
                                    <span className="active">
                                        <span className="fw-600 right-price">{numb(cartItems.price || 0)}€</span>
                                    </span>
                                </li>
                                <li className="bg-gray-dark fw-600">
                                    Totale (IVA inclusa)
                                    <span className="active">
                                        <span className="fw-600 right-price ms-2">
                                            {numb(cartItems.price_vat_included || 0)}€
                                        </span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="section mt-3 w-100">
                        <button 
                            type="button" 
                            className={`btn btn-primary btn-block mt-1 mb-05 ${newAddress && buildingData?.organization ? '' : 'disabled'}`}
                            onClick={() => setStep(2)}
                        >
                            Scegli la data <IoChevronForwardOutline className="next-icon-btn" />
                        </button>
                    </div>

                </>}

                {step === 2 && <>
                    <ReservationCalendar 
                        {...{
                            buildingData,
                            cartItems,
                            nextStep: () => setStep(3),
                            setSelectedTimeSlot,
                            photographers,
                            showExtraHeader: false,
                            extendedRange: true,
                        }}
                    />
                </>}

                {step === 3 && <>
                    <ReservationCheckout 
                        {...{
                            buildingData,
                            cartItems,
                            selectedTimeSlot,
                            isInProgress,
                            isCartInProgress,
                            checkoutData,
                            handleChangeCheckoutData,
                            completeCheckout,
                            couponData,
                            applyCoupon,
                            showExtraHeader: false,
                            showAgentOnSize: false,
                            showNote: !!productData?.placeholder_note
                        }}
                    />
                </>}

                <BottomMenu 
                    cartItems={cartItems}
                    nextStep={() => setStep(3)}
                    subscription={subscription}
                    show={step === 2 && user.is_admin}
                />
            </Capsule>
            <OffcanvasServiceInfo
                product={showOffCanvasServiceInfo}
                handleClose={() => setShowOffCanvasServiceInfo('CLOSE')}
                isPersonalBrand
            />
            <ModalConfirm 
                confirmData={reservationConfirmData}
                handleClose={handleCloseConfirm}
            />
        </>

    );
}

export default PersonalBrand;